import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

  body {
    margin: 0;
    padding: 0;
    font-family: 'Contrail One', Helvetica, sans-serif;
    background-color: black;
  }
`;

export default GlobalStyles;
